/* eslint-disable new-cap */
/* eslint-disable camelcase */
import ko from 'knockout';
import _ from 'underscore';
import schemas from '@bingads-webui-campaign/campaign-ui-schemas';
// import i18n from '$/i18n!campaignui/campaign-creation-advanced';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import config from '@bingads-webui-component-legacy/config/index';

export default class ViewModel {
  constructor({
    campaignId = null,
    DomainName = '',
    DomainLanguage = '',
    Source = '',
    disabled = false,
    dynamicDescriptionEnabled = true,
    isMixedDSACampaignRecommendation = false,
  }) {

    const permissions = config.get('Permissions');

    this.isTargetingSourceEnabled = ko.computed(() => {
      return _.result(permissions, 'IsDynamicSearchAdsPageFeedEnabled');
    }, this);

    this.isDynamicDescriptionPhase1Enabled = ko.computed(() => {
      return _.result(permissions.dynamic, 'DSADynamicDescriptionPhase1') && !isMixedDSACampaignRecommendation;
    }, this);

    this.TargetingSourceSetting = ko.observable();

    this.DomainName = ko.observable(DomainName);
    this.LanguageCode = ko.observable(DomainLanguage);

    if (this.isTargetingSourceEnabled()) {
      this.TargetingSourceSetting({ // eslint-disable-line
        Source: Source || 'SystemIndex',
      });
    }

    this.Id = ko.observable(campaignId);

    this.disabled = ko.observable(disabled);

    if (this.isDynamicDescriptionPhase1Enabled()) {
      this.isDynamicDescriptionChecked = ko.observable(dynamicDescriptionEnabled);
    }

    this.campaignProps = ['DomainName', 'LanguageCode', 'Source'];
    ko_schema.properties(this, schemas.Campaign, this.campaignProps, {
      Source,
      DomainName,
      LanguageCode: DomainLanguage,
    });
  }
}
